import config from './default/config.json';

export default config;
